import { Link } from "react-router-dom";
import { hasAnyPermission } from "@tih/shared";
import { AdminIcon, type AdminIconName } from "../../components/admin/AdminIcon";
import { useAuth } from "../../context/AuthContext";

type HubCard = {
  to: string;
  label: string;
  description: string;
  icon: AdminIconName;
  /** Any of these features unlock the card. */
  features: Array<"inbox" | "sms">;
  prominent?: boolean;
};

const CARDS: HubCard[] = [
  {
    to: "/admin/people/address-book",
    label: "Address book",
    description: "Manage everyone — import, edit, attendance history",
    icon: "people",
    features: ["inbox", "sms"],
    prominent: true,
  },
  {
    to: "/admin/testimonials",
    label: "Testimonies",
    description: "Review and publish guest stories",
    icon: "testimony",
    features: ["inbox"],
  },
  {
    to: "/admin/participation",
    label: "Participation",
    description: "Overnight responses and prompts",
    icon: "participation",
    features: ["inbox"],
  },
  {
    to: "/admin/partners",
    label: "Partners",
    description: "Partnership inquiries",
    icon: "partner",
    features: ["inbox"],
  },
  {
    to: "/admin/contact",
    label: "Messages",
    description: "Contact form inbox",
    icon: "message",
    features: ["inbox"],
  },
  {
    to: "/admin/subscribers",
    label: "Subscribers",
    description: "Email list and exports",
    icon: "subscriber",
    features: ["inbox"],
  },
  {
    to: "/admin/comments",
    label: "Live comments",
    description: "Moderate chat on the live page",
    icon: "comment",
    features: ["inbox"],
  },
  {
    to: "/admin/communication",
    label: "SMS",
    description: "Compose and send broadcasts",
    icon: "sms",
    features: ["sms"],
  },
];

export function AdminPeoplePage() {
  const { user } = useAuth();
  const cards = CARDS.filter((c) => hasAnyPermission(user, c.features));

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>People</h1>
        <p>Inbox, community, address book, and outreach.</p>
      </header>

      {cards.length > 0 ? (
        <div className="admin-hub-grid">
          {cards.map((card) => (
            <Link
              key={card.to}
              to={card.to}
              className={`admin-hub-card${card.prominent ? " admin-hub-card-featured" : ""}`}
            >
              <span className="admin-hub-card-icon" aria-hidden>
                <AdminIcon name={card.icon} size={22} />
              </span>
              <span className="admin-hub-card-body">
                <strong>{card.label}</strong>
                <span>{card.description}</span>
              </span>
            </Link>
          ))}
        </div>
      ) : (
        <div className="admin-hub-empty admin-card">
          <p>No People tools are available on this account.</p>
          <Link to="/admin" className="btn btn-ghost">
            Back to dashboard
          </Link>
        </div>
      )}
    </div>
  );
}
